<ng-template [sbmodal]="'mediaexplorermodal'">
  <sb-custom-modal [templateId]="'mediaexplorermodal'">
    <div slot="body">
      <sb-page-medium-explorer [customer]="customer" [modalType]="'bookingSelect'"
                               [isInModalContext]="'mediaexplorermodal'"></sb-page-medium-explorer>
    </div>
  </sb-custom-modal>
</ng-template>
<div class="tw-flex tw-justify-between" *ngIf="!planningId"> <!-- TODO PMI-302 make accessible in planning view -->

  <!-- assignedMediumGroup -->
  <div class="tw-flex tw-flex-col" *ngPermissions="permissionService.Permission.medium_group_list">
    <h5>{{ 'lang.globals.mainMediumGroup' | translate }}</h5>
    <div class="tw-flex tw-p-2 tw-flex-grow">
      <sb-comp-image-name-wrapper class="tw-mr-40" [medium]="requirementData?.assignedMediumGroup?.preview" [still]="true">
        <span firstLine>{{ requirementData?.assignedMediumGroup?.name ?? ('lang.globals.noSelection' |translate) }}</span>
        <span secondLine
              *ngIf="requirementData?.assignedMediumGroup?.mediaCount">{{ requirementData?.assignedMediumGroup?.mediaCount }} {{ 'lang.globals.medias' |translate }}</span>
      </sb-comp-image-name-wrapper>

      <div class="tw-flex tw-gap-2 tw-items-center">
        <button sb-button-secondary [iconButton]="true" color="blue" type="button" (click)="selectMotiveGroup(true)">
          <sb-icon icon="selection"></sb-icon>
        </button>
        <button sb-button-secondary [iconButton]="true" color="red" type="button" [disabled]="!requirementData.assignedMediumGroup"
                (click)="removeMainMediumGroup()">
          <sb-icon icon="trash"></sb-icon>
        </button>
      </div>
    </div>
  </div>


  <!-- assignedTemplateDataSet -->
  <div class="tw-flex tw-flex-col" *ngPermissions="permissionService.Permission.template_data_set_list">
    <h5>{{ 'lang.globals.mainTemplateDataSet' | translate }}</h5>
    <div class="tw-flex tw-items-center tw-flex-grow tw-p-2 ">
      <div class="tw-mr-40">
        @if (requirementData?.assignedTemplateDataSet) {
          @if (requirementData?.assignedTemplateDataSetEntry) {
            <div class="tw-font-bold">{{ requirementData?.assignedTemplateDataSetEntry.name }}</div>
            <div>{{ 'lang.globals.from' | translate }}</div>
            <div>{{ requirementData?.assignedTemplateDataSet.name }}</div>
          } @else {
            <div class="tw-italic">{{ 'lang.globals.all' | translate }}</div>
            <div>{{ 'lang.globals.from' | translate }}</div>
            <div class="tw-font-bold">{{ requirementData?.assignedTemplateDataSet?.name }}</div>
          }
        } @else {
          {{ 'lang.globals.noSelection' | translate }}
        }
      </div>
      <div class="tw-flex tw-gap-2 tw-items-center">
        <button sb-button-secondary [iconButton]="true" color="blue" type="button"
                [disabled]="getAssignedTemplateDataSetDisabled()|| hasDifferentTemplateGroups()"
                (click)="selectTemplateDataSetOverride(true)">
          <sb-icon icon="selection"></sb-icon>
        </button>
        <button sb-button-secondary [iconButton]="true" color="red" type="button" [disabled]="!requirementData.assignedTemplateDataSet"
                (click)="removeMainTemplateDataSet()">
          <sb-icon icon="trash"></sb-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="tw-flex tw-flex-col">
    <h5>&nbsp;</h5>
    <div class="tw-flex tw-items-center tw-flex-grow tw-font-bold tw-text-sbGray-400">
      <span class="" (click)="requirementData.assignedTemplateDataSet || requirementData.assignedMediumGroup ? toggleAutoBook() : null"
            [ngClass]="{'blue': (requirementData.assignedTemplateDataSet || requirementData.assignedMediumGroup) && !requirementData.autoBook}"
      >
     {{ 'lang.booking.manualBooking'|translate }}
      </span>
      <div class="form-check form-switch tw-ml-4 tw-mr-2">
        <input type="checkbox" role="switch" id="autoBook" class="form-check-input custom-switch"
               [disabled]="!requirementData.assignedTemplateDataSet && !requirementData.assignedMediumGroup"
               [checked]="requirementData.autoBook" (click)="toggleAutoBook()" />
      </div>
      <span (click)="requirementData.assignedTemplateDataSet || requirementData.assignedMediumGroup ? toggleAutoBook() : null"
            [ngClass]="{'blue': (requirementData.assignedTemplateDataSet || requirementData.assignedMediumGroup) && requirementData.autoBook}">
     {{ 'lang.booking.autoBooking'|translate }}
      </span>
      <div class="tw-flex tw-items-center tw-p-1 tw-text-violet-500 tw-bg-fuchsia-100 tw-rounded-3xl tw-ml-4">
        <sb-icon icon="questionmark" [ngbTooltip]=" 'lang.booking.autoBookingInfotext' |translate" container="body"></sb-icon>
      </div>
    </div>
  </div>

</div>

<hr class="tw-my-6">
<!-- requirement Booking assignment -->
<div class="d-flex justify-content-between mb-5">
  <div>
    <ng-container *ngPermissions="permissionService.Permission.medium_upload">
      <h5>{{ bookingService.countActiveBookings(bookingPreviewData) <= 1 ? bookingService.countActiveBookings(bookingPreviewData) + ' ' + ('lang.globals.activeBooking' | translate) : bookingService.countActiveBookings(bookingPreviewData) + ' ' + ('lang.globals.activeBookings' | translate) }} </h5>
      <span
        class="blue d-inline-flex align-items-center font-weight-bolder">{{ 'lang.requirementBookingAssignment.forgotTo' | translate }}&nbsp;
          <a class="link" target="_blank" [sbRouterLink]="util.RoutingID.mediumExplorer"
             [queryParams]="customer ? {company: customer.id} : null">{{ 'lang.requirementBookingAssignment.uploadMotives' | translate }}</a></span>
    </ng-container>
  </div>
  <div class="d-flex flex-column">
    <div class="d-flex justify-content-end w-100 mb-3">
      <div container="body"
           [ngbTooltip]="(bookingService.countDeprecatedBookings(bookingPreviewData) === 0 && !showDeprecatedBookings) ? noDeprecatedBookings() : null"
           class="d-flex">
        {{ 'lang.requirementBookingAssignment.showDeprecated' | translate }}
        <div class="form-check form-switch ml-3">
          <input
            [disabled]="bookingService.countDeprecatedBookings(bookingPreviewData) === 0 && !showDeprecatedBookings"
            type="checkbox" role="switch" class="form-check-input" [id]='"customSwitchShowDeprecated"'
            [(ngModel)]="showDeprecatedBookings">
          <label class="form-check-label" [for]='"customSwitchShowDeprecated"'></label>
        </div>
      </div>
      <div container="body"
           [ngbTooltip]="(bookingService.countExcludedBookings(bookingPreviewData) === 0 && !showExcludedBookings) ? noExcludedBookings() : null"
           placement="top" class="d-flex mr-3">
        {{ 'lang.requirementBookingAssignment.showExcluded' | translate }}
        <div class="form-check form-switch ml-3">
          <input
            [disabled]="bookingService.countExcludedBookings(bookingPreviewData) === 0 && !showExcludedBookings"
            type="checkbox" role="switch" class="form-check-input" [id]='"customSwitchShowExcluded"'
            [(ngModel)]="showExcludedBookings">
          <label class="form-check-label" [for]='"customSwitchShowExcluded"'></label>
        </div>
      </div>
    </div>
    <div class="d-flex">
      <button *ngIf="!readonlyCommercial && permissionService.hasPermission(permissionService.Permission.medium_group_list)"
              (click)="selectMotiveGroup()" class="btn btn-success font-weight-bolder font-size-sm w-100 mr-2">
        <sb-icon class="mr-1" icon="motives"></sb-icon>
        {{ 'lang.requirementBookingAssignment.useMotivegroup' | translate }}
      </button>
      <button *ngIf="!readonlyCommercial && permissionService.hasPermission(permissionService.Permission.template_data_set_list)"
              (click)="selectTemplateDataSetOverride()" [disabled]="getAssignedTemplateDataSetDisabled() || hasDifferentTemplateGroups()"
              class="btn btn-success font-weight-bolder font-size-sm w-100 mr-2">
        <sb-icon class="mr-1" icon="template"></sb-icon>
        {{ 'lang.requirementBookingAssignment.useTemplateDataSet' | translate }}
      </button>
      <button *ngIf="!isInIntegratedContext" (click)="disableBookingsAsk()"
              [disabled]="bookingService.countMissingBookings(bookingPreviewData)===0"
              class="btn btn-default font-weight-bolder font-size-sm w-100 mr-2">
        <sb-icon class="mr-1" icon="toggleOn"></sb-icon>
        {{ 'lang.requirementBookingAssignment.excludeUnassignedBookingsCount' | translate: { count: bookingService.countMissingBookings(bookingPreviewData) } }}
      </button>
      <button *ngIf="!isInIntegratedContext" (click)="disableBookingsAsk('excludeAll')"
              [disabled]="bookingService.countExcludedBookings(bookingPreviewData) === bookingPreviewData?.length"
              class="btn btn-default font-weight-bolder font-size-sm w-100">
        <sb-icon class="mr-1" icon="toggleOn"></sb-icon>
        {{ 'lang.requirementBookingAssignment.excludeAllBookings' | translate }}
      </button>
    </div>
  </div>
</div>

<ng-container *ngIf="bookingPreviewData">
  <div *ngIf="hasDifferentTemplateGroups()" class="tw-rounded-lg tw-bg-yellow-500 tw-text-white tw-flex tw-gap-2.5 tw-p-3 tw-font-bold">
    <sb-icon icon="attention"></sb-icon>
    <div>
      {{ 'lang.requirementBookingAssignment.differentTemplateDataset' | translate }}
    </div>
  </div>
  <div class="tw-overflow-x-auto">
    <table class="table tableBg">
      <thead>
      <tr>
        <th>{{ 'lang.globals.status' | translate }}</th>
        <th>{{ 'lang.requirementBookingAssignment.selectedMotive' | translate }}</th>
        <th>{{ 'lang.globals.publisher' | translate }}</th>
        <th>{{ 'lang.globals.channel' | translate }}</th>
        <th>{{ 'lang.requirementBookingAssignment.marker' | translate }}</th>
        <th>{{ 'lang.globals.resolution' | translate }}</th>
        <th *ngIf="hasTemplateDataSetColumn">{{ 'lang.globals.templateDataset' | translate }}</th>
        <th class="text-end">
          {{ 'lang.globals.actions' | translate }}
        </th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let booking of bookingPreviewData">
        <ng-container *ngIf="showDeprecatedBookings || !booking.deprecated">
          <tr *ngIf="showExcludedBookings || !booking.excluded"
              [ngbTooltip]="durationCheck(booking.medium) ? ('lang.commercial.durationWarning'|translate) : ''"
              [openDelay]="1000" container="body"
              [ngClass]="{
              ' bg-light ' : !booking.deprecated ? !booking.medium || booking.excluded : null,
              ' deprecated-bg ' : booking.deprecated,
              ' durationWarning ': durationCheck(booking.medium)
              }">
            <td>
              <sb-comp-booking-status [booking]="booking"></sb-comp-booking-status>
            </td>
            <td>
              <sb-comp-image-name-wrapper [medium]="booking?.medium" [thumbnailSize]="'S'" [still]="true">
                <span firstLine class="font-size-lg" [innerHTML]="booking?.medium?.name | truncate : 40"></span>
                <span secondLine class="font-weight-bold text-muted"
                      [innerHTML]="booking?.medium?.mediumGroup?.name | truncate : 40"></span>
              </sb-comp-image-name-wrapper>
            </td>
            <td>
              <sb-comp-image-name-wrapper [image]="booking?.publisher?.logo?.url">
                <span firstLine [innerHTML]="booking?.publisher?.name | truncate : 35"></span>
              </sb-comp-image-name-wrapper>
            </td>
            <td>
              <sb-comp-image-name-wrapper [image]="booking?.channel?.logo?.url">
                <span firstLine [innerHTML]="booking?.channel?.name | truncate:30"></span>
                <span secondLine [innerHTML]="booking?.channel?.description | truncate: 30"></span>
              </sb-comp-image-name-wrapper>
            </td>
            <td>
              {{ booking?.marker?.name }}
            </td>
            <td>
              <span>{{ booking?.marker?.resolution?.id }}</span>
            </td>
            <td *ngIf="hasTemplateDataSetColumn">
              <div class="tw-flex tw-flex-col">
                @if (booking.templateDataSet) {
                  @if (booking?.templateDataSetEntry) {
                    <div class="tw-font-bold">{{ booking.templateDataSetEntry.name }}</div>
                    <div>{{ 'lang.globals.from' | translate }}</div>
                    <div>{{ booking?.templateDataSet?.name }}</div>
                  } @else {
                    <div class="tw-italic">{{ 'lang.globals.all' | translate }}</div>
                    <div>{{ 'lang.globals.from' | translate }}</div>
                    <div class="tw-font-bold">{{ booking?.templateDataSet?.name }}</div>
                  }
                } @else {
                  -
                }
              </div>
            </td>
            <td>
              <div class="d-flex align-items-center justify-content-end">
                <ng-container *ngIf="!readonlyCommercial">
                  <button *ngIf="booking.medium?.templateGroup" container="body"
                          ngbTooltip="{{ 'lang.requirementBookingAssignment.assignTemplateDataset' | translate }}"
                          placement="left" (click)="selectTemplateDataSet($event, booking)" class="btn-secondary btn mr-2">
                    <sb-icon icon="datasets"></sb-icon>
                  </button>
                  <button
                    *ngIf="booking.medium?.templateGroup"
                    [disabled]="!booking.templateDataSet" container="body"
                    ngbTooltip="{{ 'lang.requirementBookingAssignment.removeTemplateFromBooking' | translate }}"
                    placement="left" (click)="removeTemplateAsk(booking)" class="btn btn-secondary mr-2">
                    <sb-icon icon="minus"></sb-icon>
                  </button>
                  <button *ngIf="booking?.medium" container="body"
                          ngbTooltip="{{ 'lang.requirementBookingAssignment.changeMotive' | translate }}"
                          placement="left" (click)="openMediaModal($event, booking)" class="btn-primary btn mr-2"
                          [ngClass]="getClass(booking?.medium)">
                    <sb-icon icon="motiveSwap"></sb-icon>
                  </button>
                  <button *ngIf="!booking?.medium" container="body"
                          ngbTooltip="{{ 'lang.requirementBookingAssignment.assignMotive' | translate }}"
                          placement="left" (click)="openMediaModal($event, booking)" class="btn-primary btn mr-2"
                          [ngClass]="getClass(booking?.medium)">
                    <sb-icon icon="motiveExplorer"></sb-icon>
                  </button>
                  <button [disabled]="!booking.medium" container="body"
                          ngbTooltip="{{ 'lang.requirementBookingAssignment.removeMotiveFromBooking' | translate }}"
                          placement="left" (click)="removeMotiveAsk(booking)" class="btn btn-secondary">
                    <sb-icon icon="minus"></sb-icon>
                  </button>
                  <div ngbTooltip="{{'lang.requirementBookingAssignment.exclude' | translate}}" placement="left"
                       container="body"
                       class="form-check form-switch ml-3">
                    <input #disableBookingToggle type="checkbox" role="switch" class="form-check-input"
                           [id]='"customSwitch" + booking.id'
                           [checked]="booking.excluded" (change)="toggleDisableBooking($event, booking)">
                    <label class="form-check-label" [for]='"customSwitch" + booking.id'></label>
                  </div>
                </ng-container>
              </div>
            </td>
          </tr>
        </ng-container>
      </ng-container>
      </tbody>
    </table>
  </div>
  <div class="d-flex tw-justify-center tw-w-full tw-mt-10">
    <button class="btn btn-primary" (click)="showMarkerList()">{{ 'lang.globals.addBooking' | translate }}</button>
  </div>
</ng-container>
